
import mainLogo from "../assets/img/mainLogo.svg";

const Logo = () => {
  return (
    <img src={mainLogo} alt="logo" style={{width: "100%", objectFit: "contain"}} />
  )
}

export default Logo